<template>
    <div class="w-28">
        <ConfiguratorUtilsProgressBar :percentage="configurator.progressBar.percentage" />
    </div>

    <ConfiguratorUtilsButton
        @click="
            navigateTo({
                name: 'configurators-configuratorId-groups-groupId-steps-stepId',
                params: {
                    configuratorId: configurator.getId(),
                    groupId: configurator.form.current?.group,
                    stepId: configurator.form.current?.step,
                },
            })
        "
        >{{ $t('configurator.go') }}
    </ConfiguratorUtilsButton>
</template>

<script lang="ts" setup>
    import Configurator from '~/app/common/models/Configurator';

    defineProps<{
        configurator: Configurator;
    }>();
</script>
